import { INIT_ACCOUNT, INIT_DEPARTMENT } from "constants/filter";
import { Department } from "utils/accountUtils";

export type FilterChoice = { key?: number | string; label: string; value: string; disabled?: boolean };

const isAllAccount = (account: Account): boolean => account.id === INIT_ACCOUNT.id;

export const buildDepartmentFilterChoices = (departments: Department[]): FilterChoice[] => [
  { label: INIT_DEPARTMENT, key: INIT_DEPARTMENT, value: INIT_DEPARTMENT },
  ...departments.filter((department) => department.value !== INIT_DEPARTMENT),
];

export const buildAccountFilterChoices = (accounts: Account[]): FilterChoice[] => [
  { label: INIT_ACCOUNT.name, key: INIT_ACCOUNT.id, value: INIT_ACCOUNT.name },
  ...accounts
    .filter((account) => !isAllAccount(account))
    .map((account) => ({
      label: account.name,
      key: account.id,
      value: account.name,
    })),
];

export const filterAccountsByDepartment = (accounts: Account[], department: string | undefined): Account[] => {
  const realAccounts = accounts.filter((account) => !isAllAccount(account));
  if (!department || department === INIT_DEPARTMENT) {
    return realAccounts;
  }
  return realAccounts.filter((account) => account.department === department);
};

export const toDepartmentFilterDisplayValue = (department: string | undefined): string =>
  !department || department === INIT_DEPARTMENT ? INIT_DEPARTMENT : department;

export const toAccountFilterDisplayValue = (account: Account | undefined): string =>
  !account || account.id === INIT_ACCOUNT.id ? INIT_ACCOUNT.name : account.name;
